import { createLazyFileRoute, Outlet } from "@tanstack/react-router";
import { memo } from "react";

import { AccessionView } from "@/features/subjects/components/SubjectAccessionView";

export const Route = createLazyFileRoute("/_auth/_app/subjects/$id/accession")({
  component: memo(() => {
    const { accessionId } = Route.useSearch();
    return (
      <>
        <AccessionView accessionId={accessionId} />
        <Outlet />
      </>
    );
  }),
});
